import { EPromoStatus } from 'models/promoCodes'
import { Tag } from 'antd'

interface IPromoStatusItemData {
  key: EPromoStatus
  label: React.ReactNode
}

export const MAX_PROMO_TIERS = 10

export const promoCodesStatuses = {
  [EPromoStatus.ACTIVE]: {
    value: EPromoStatus.ACTIVE,
    label: 'Активен',
    color: 'green'
  },
  [EPromoStatus.EXPIRED]: {
    value: EPromoStatus.EXPIRED,
    label: 'Истёк',
    color: 'default'
  },
  [EPromoStatus.ARCHIVED]: {
    value: EPromoStatus.ARCHIVED,
    label: 'Архив',
    color: 'red'
  }
}

const activeStatus: IPromoStatusItemData = {
  key: EPromoStatus.ACTIVE,
  label: (
    <Tag color={promoCodesStatuses[EPromoStatus.ACTIVE].color}>
      {promoCodesStatuses[EPromoStatus.ACTIVE].label}
    </Tag>
  )
}

const expiredStatus: IPromoStatusItemData = {
  key: EPromoStatus.EXPIRED,
  label: (
    <Tag color={promoCodesStatuses[EPromoStatus.EXPIRED].color}>
      {promoCodesStatuses[EPromoStatus.EXPIRED].label}
    </Tag>
  )
}

const archivedStatus: IPromoStatusItemData = {
  key: EPromoStatus.ARCHIVED,
  label: (
    <Tag color={promoCodesStatuses[EPromoStatus.ARCHIVED].color}>
      {promoCodesStatuses[EPromoStatus.ARCHIVED].label}
    </Tag>
  )
}

export const getPromoCodesStatusItems = (
  status: EPromoStatus
): IPromoStatusItemData[] => {
  if (status === EPromoStatus.ACTIVE) {
    return [archivedStatus, expiredStatus]
  }
  if (status === EPromoStatus.EXPIRED) {
    return [activeStatus, archivedStatus]
  }
  if (status === EPromoStatus.ARCHIVED) {
    return [activeStatus, expiredStatus]
  }
  return []
}
